module.exports = __webpack_public_path__ + "img/gomb-fokusz.8b00dfae.png";